const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/manage/groups/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/manage/groups/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(z.object({
    page: z.number().int().optional(),
    pageSize: z.number().int().optional(),
    /** Legacy id of the group whose children are being listed. */
    parentId: z.number().int().optional()
  })),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "{erg_p}",
      description: "Page title"
    })
  }
});